<script lang="ts">
	export let nounText: string;
	export let verbText = '';
	export let disabled = false;
</script>

<button
	class="btn btn-sm btn-secondary rounded-0 me-md-2"
	type="button"
	{disabled}
	on:click|preventDefault
>
	<span class="pr-025 normal-case">
		{nounText}
		{#if verbText}
			<span class="d-none d-md-inline-block">{verbText}</span>
		{/if}
	</span>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11.129"
		height="11.129"
		viewBox="0 0 11.129 11.129"
	>
		<path
			id="Icon_material-edit"
			data-name="Icon material-edit"
			d="M4.5,13.307v2.318H6.818l6.837-6.837L11.337,6.47ZM15.449,7a.616.616,0,0,0,0-.872L14,4.677a.616.616,0,0,0-.872,0L12,5.808l2.318,2.318L15.449,7Z"
			transform="translate(-4.5 -4.496)"
			fill="#040404"
		/>
	</svg>
</button>

<style>
	button {
		background: transparent;
		box-shadow: none;
		border-color: #040404;
		color: #040404;
		transition: all linear 0.2s;
	}

	button:hover {
		background: transparent;
		border-color: #040404;
		color: #040404;
	}
</style>
